module.exports = __webpack_public_path__ + "static/img/shareIcon.94132dba.png";